import { CountryId } from '@previo/codebooks'
import { CZECountryStrategy } from '~/pages/setting/applications/accounting/exports/software/i10n/countries/CZECountryStrategy'
import { SVKCountryStrategy } from '~/pages/setting/applications/accounting/exports/software/i10n/countries/SVKCountryStrategy'
import { DefaultCountryStrategy } from '~/pages/setting/applications/accounting/exports/software/i10n/countries/DefaultCountryStrategy'

export function useCountryStrategy(countryId: null | CountryId) {
  switch (countryId) {
    case CountryId.CZE:
      return new CZECountryStrategy()
    case CountryId.SVK:
      return new SVKCountryStrategy()
    default:
      return new DefaultCountryStrategy()
  }
}
